import { WaterPercentIcon } from './WaterPercentIcon';

/**
 * author: Simran
 * id 2CE24A47-D798-4FFD-A53D-65FE9D452E2F
 * name water-percent
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-percent.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Nature 
 */
export const InkPercentIcon = WaterPercentIcon;
export default InkPercentIcon